import { Navigate } from 'react-router-dom';
import { ROUTES } from '../routes/routes';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true';

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.WELCOME} replace />;
  }

  return children;
};

export default ProtectedRoute;
